export default __webpack_public_path__ + "images/KK.5e41ceb.png";